import { useTranslation } from "react-i18next";
import type { MetricLabel as MetricLabelType } from "../../modules/merchandising/utils/metrics";

// Every column/metric label selector points to `$.metrics[...]`, so binding the `metrics`
// namespace here is enough — i18next-resources-to-backend lazy-loads it on first render
// and suspends to the root boundary in App.tsx. Consumer pages don't need to know about it.
// The `<span>` is load-bearing (TRELLIS-UI-4AF): a bare `<>{text}</>` leaves the text node as the
// topmost host node of this subtree, so React removes it directly when the label unmounts. The
// deletion boundary is inside this component, so a wrapper added by the consumer cannot fix it.
export function MetricLabel({ label }: { label: MetricLabelType | string | undefined }) {
  const { t } = useTranslation(["metrics"]);
  if (label == null) return null;
  if (typeof label === "string") return <span>{label}</span>;
  return <span>{t(label)}</span>;
}
